import { merge, get, set, clone, concat } from 'lodash';
import { ACTIONBASEINFO, ACITONCOPYRIGHT } from '../../../actionTypes';
let initState = {
	cityList: [],
	baseinfo: {},
	awss3Token: {},
	isUpdate: 0,
	globalSearchString: '',
	searchToutuData: {
		talCount: 0,
		pageIndex: 1,
		pageSize: 10,
		topices: [],
		contents: []
	},
	topicConfigList: [],
	bannerConfigList: []
};
export function CopyrightBaseinfoReducers(state = initState, action) {
	switch (action.type) {
		case ACTIONBASEINFO.SET_BASEINFO_CITYLIST: {
			let { citys } = get(action, 'payload.data', []);
			if (get(citys, 'length') > 0) {
				state.cityList = citys;
				return merge({}, state, {});
			}
			return state;
		}
		case ACITONCOPYRIGHT.SET_COPYRIGHT_BASEINFO: {
			let { payload } = action;
			if (payload) {
				console.log('payload...', payload);
				state.baseinfo = merge({}, state.baseinfo, payload);
				return merge({}, state, {});
			}
			return state;
		}
		case ACITONCOPYRIGHT.SET_UPLOAD_TOKENINFO: {
			let { payload } = action;
			console.log('upload payload token', payload);
			state.awss3Token = payload;
			return merge({}, state, {});
		}
		case ACITONCOPYRIGHT.SET_SEARCH_TOUTUINFO: {
			let { payload } = action;
			let { result, searchType, tag } = payload;
			let { totalCount, pageIndex, pageSize, records } = result || {};
			console.log('data payload...', payload);
			let { topicResps = [], topicContentResponses = [] } = get(records, [0], []);
			console.log('topicResps', topicResps);
			state.globalSearchString = tag;
			if (pageIndex === 1) {
				state.searchToutuData = {
					totalCount,
					pageIndex,
					pageSize,
					topices: topicResps,
					contents: topicContentResponses
				};
			} else if (searchType === 1 || searchType === 3 || searchType === 4) {
				state.searchToutuData.contents = clone(state.searchToutuData.contents.concat(topicContentResponses));
				state.searchToutuData.totalCount = totalCount;
				state.searchToutuData.pageIndex = pageIndex;
			} else if (searchType === 2) {
				state.searchToutuData.topices = state.searchToutuData.topices.concat(topicResps);
				state.searchToutuData.totalCount = totalCount;
				state.searchToutuData.pageIndex = pageIndex;
			}
			state.isUpdate = 1;
			console.log('new state ', state.searchToutuData);
			return clone(state);
		}
		case ACITONCOPYRIGHT.SET_TOPICCONIFG_LIST: {
			let { payload } = action;
			console.log('payload topic config list ...', payload);
			state.topicConfigList = payload || [];
			return merge({}, state, {});
		}
		case ACITONCOPYRIGHT.SET_BANNERCONIFG_LIST: {
			let { payload } = action;
			console.log('payload banner config list ...', payload);
			payload = payload.sort((a, b) => {
				return a.bannerPosition - b.bannerPosition;
			});
			state.bannerConfigList = payload || [];
			return merge({}, state, {});
		}
		case ACITONCOPYRIGHT.SET_ACTIVITYCONIFG_LIST: {
			let { payload } = action;
			console.log('payload activity config list ...', payload);
			payload = payload.sort((a, b) => {
				return a.activityPosition - b.activityPosition;
			});
			state.activityConfigList = payload || [];
			return merge({}, state, {});
		}
		case ACITONCOPYRIGHT.SET_GALLERYIMG_SEARCH: {
			let payload = get(action, 'payload', []);
			let { index, operation = 0 } = payload;
			state.searchToutuData.contents[index].likeStatus = operation;
			console.log('index...', index);
			state.searchToutuData.contents[index].likeStatus = operation;
			if (operation) {
				//+1
				++state.searchToutuData.contents[index].endorseCount;
			} else {
				//-1
				--state.searchToutuData.contents[index].endorseCount;
			}
			return merge({}, state, {});
		}
		default:
			return state;
	}
}
